export const SKILLS_WEB_PATH = "/skills";

/**
 * Build the outbound Skills management URL for standalone Finster or a
 * tenant Finster web-app host configured via `FINSTER_WEB_URL`.
 */
export function buildSkillsManagementUrl(
  baseUrl?: string
): string | undefined {
  const normalizedBaseUrl = baseUrl?.trim();
  if (!normalizedBaseUrl) return undefined;

  try {
    const baseUrlObject = new URL(normalizedBaseUrl);
    if (
      baseUrlObject.protocol !== "https:" &&
      baseUrlObject.protocol !== "http:"
    ) {
      return undefined;
    }
    baseUrlObject.search = "";
    baseUrlObject.hash = "";
    if (!baseUrlObject.pathname.endsWith("/")) {
      baseUrlObject.pathname = `${baseUrlObject.pathname}/`;
    }
    const url = new URL(
      SKILLS_WEB_PATH.replace(/^\//, ""),
      baseUrlObject
    );
    url.search = "";
    url.hash = "";
    return url.toString();
  } catch {
    return undefined;
  }
}
